 module.exports = {
    CLEAR_LOAN_MOVEMENTS_FILTERS: 'CLEAR_LOAN_MOVEMENTS_FILTERS',
    CLEAR_LOAN_SETTLEMENTS_FILTERS: 'CLEAR_LOAN_SETTLEMENTS_FILTERS',

    COLLECTIVE_LOAN_REQUEST: 'COLLECTIVE_LOAN_REQUEST',
    COLLECTIVE_LOAN_SUCCESS: 'COLLECTIVE_LOAN_SUCCESS',
    COLLECTIVE_LOAN_FAILURE: 'COLLECTIVE_LOAN_FAILURE',
    
    CONTRACT_PRE_GRANTED_CREDIT_OFFICE_PRINT:'CONTRACT_PRE_GRANTED_CREDIT_OFFICE_PRINT',
    CONTRACT_PRE_GRANTED_CREDIT_OFFICE_CONTRACT_PRINT:'CONTRACT_PRE_GRANTED_CREDIT_OFFICE_CONTRACT_PRINT',
    CONTRACT_EASY_LOAN_INIT_ONE_SUCCESS:'CONTRACT_EASY_LOAN_INIT_ONE_SUCCESS',
    INIT_CONTRACT_EASY_LOAN_ONE_SUCCESS:'INIT_CONTRACT_EASY_LOAN_ONE_SUCCESS',
    CONTRACT_EASY_LOAN_INIT_TWO_SUCCESS:'CONTRACT_EASY_LOAN_INIT_TWO_SUCCESS',
    CONTRACT_EASY_LOAN_INIT_ERROR:'CONTRACT_EASY_LOAN_INIT_ERROR',
    CONTRACT_EASY_LOAN_INIT_LOADING:'CONTRACT_EASY_LOAN_INIT_LOADING',
    CONTRACT_EASY_LOAN_AGREE_RESET:'CONTRACT_EASY_LOAN_AGREE_RESET',
    FETCH_LOAN_GENERAL_DATA_FAILURE: 'FETCH_LOAN_GENERAL_DATA_FAILURE',
    FETCH_LOAN_GENERAL_DATA_SUCCESS: 'FETCH_LOAN_GENERAL_DATA_SUCCESS',
    FETCH_LOAN_GENERAL_DATA: 'FETCH_LOAN_GENERAL_DATA',

    FETCH_LOAN_INTERVENERS_FAILURE: 'FETCH_LOAN_INTERVENERS_FAILURE',
    FETCH_LOAN_INTERVENERS_SUCCESS: 'FETCH_LOAN_INTERVENERS_SUCCESS',
    FETCH_LOAN_INTERVENERS: 'FETCH_LOAN_INTERVENERS',

    FETCH_LOAN_MOVEMENTS_DETAILS_FAILURE: 'FETCH_LOAN_MOVEMENTS_DETAILS_FAILURE',
    FETCH_LOAN_MOVEMENTS_DETAILS_SUCCESS: 'FETCH_LOAN_MOVEMENTS_DETAILS_SUCCESS',
    FETCH_LOAN_MOVEMENTS_DETAILS: 'FETCH_LOAN_MOVEMENTS_DETAILS',
    FETCH_LOAN_MOVEMENTS_FAILURE: 'FETCH_LOAN_MOVEMENTS_FAILURE',
    FETCH_LOAN_MOVEMENTS_REQUEST: 'FETCH_LOAN_MOVEMENTS_REQUEST',
    FETCH_LOAN_MOVEMENTS_SUCCESS: 'FETCH_LOAN_MOVEMENTS_SUCCESS',

    FETCH_LOAN_SETTLEMENTS: 'FETCH_LOAN_SETTLEMENTS',
    FETCH_LOAN_SETTLEMENTS_SUCCESS: 'FETCH_LOAN_SETTLEMENTS_SUCCESS',
    FETCH_LOAN_SETTLEMENTS_FAILURE: 'FETCH_LOAN_SETTLEMENTS_FAILURE',
    FETCH_LOAN_SETTLEMENTS_DETAILS: 'FETCH_LOAN_SETTLEMENTS_DETAILS',
    FETCH_LOAN_SETTLEMENTS_DETAILS_SUCCESS: 'FETCH_LOAN_SETTLEMENTS_DETAILS_SUCCESS',
    FETCH_LOAN_SETTLEMENTS_DETAILS_FAILURE: 'FETCH_LOAN_SETTLEMENTS_DETAILS_FAILURE',

    GLOBAL_POSITION_REQUEST_SUCCESS: 'GLOBAL_POSITION_REQUEST_SUCCESS',

    LOAN_MOVEMENTS_FETCH_NEXT_PAGE: 'LOAN_MOVEMENTS_FETCH_NEXT_PAGE',
    LOAN_MOVEMENTS_FETCH_NEXT_PAGE_FAILURE: 'LOAN_MOVEMENTS_FETCH_NEXT_PAGE_FAILURE,',
    LOAN_MOVEMENTS_FETCH_NEXT_PAGE_SUCCESS: 'LOAN_MOVEMENTS_FETCH_NEXT_PAGE_SUCCESS',

    LOAN_REPAYMENT_PLAN_REQUEST: 'LOAN_REPAYMENT_PLAN_REQUEST',
    LOAN_REPAYMENT_PLAN_SUCCESS: 'LOAN_REPAYMENT_PLAN_SUCCESS',
    LOAN_REPAYMENT_PLAN_FAILURE: 'LOAN_REPAYMENT_PLAN_FAILURE',
    LOAN_REPAYMENT_PLAN_RESET: 'LOAN_REPAYMENT_PLAN_RESET',
    LOAN_REPAYMENT_PLAN_SET_FILTERS: 'LOAN_REPAYMENT_PLAN_SET_FILTERS',
    LOAN_REPAYMENT_PLAN_CLEAR_FILTERS: 'LOAN_REPAYMENT_PLAN_CLEAR_FILTERS',
    LOAN_REPAYMENT_PLAN_NEXT_PAGE_REQUEST: 'LOAN_REPAYMENT_PLAN_NEXT_PAGE_REQUEST',
    LOAN_REPAYMENT_PLAN_NEXT_PAGE_SUCCESS: 'LOAN_REPAYMENT_PLAN_NEXT_PAGE_SUCCESS',

    LOAN_SETTLEMENTS_SET_FILTERS: 'LOAN_SETTLEMENTS_SET_FILTERS',
    LOAN_SETTLEMENTS_FETCH_NEXT_PAGE_SUCCESS: 'LOAN_SETTLEMENTS_FETCH_NEXT_PAGE_SUCCESS',
    LOAN_SETTLEMENTS_FETCH_NEXT_PAGE: 'LOAN_SETTLEMENTS_FETCH_NEXT_PAGE',
    LOAN_SETTLEMENTS_FETCH_NEXT_PAGE_FAILURE: 'LOAN_SETTLEMENTS_FETCH_NEXT_PAGE_FAILURE',
    MORTGAGES_STATUS_REQUEST: 'MORTGAGES_STATUS_REQUEST',
    MORTGAGES_STATUS_SUCCESS: 'MORTGAGES_STATUS_SUCCESS',
    MORTGAGES_STATUS_FAILURE: 'MORTGAGES_STATUS_FAILURE',
    OFFICE_PRINT_RESET: 'OFFICE_PRINT_RESET',
    RESET_MAIL_SENT: 'RESET_MAIL_SENT',
    RESET_LOAN_MOVEMENTS_FILTER: 'RESET_LOAN_MOVEMENTS_FILTER',
    SET_LOAN_MOVEMENTS_FILTERS: 'SET_LOAN_MOVEMENTS_FILTERS',

    SET_LOAN_ALIAS_REQUEST: 'SET_LOAN_ALIAS_REQUEST',
    SET_LOAN_ALIAS_SUCCESS: 'SET_LOAN_ALIAS_SUCCESS',
    SET_LOAN_ALIAS_FAILURE: 'SET_LOAN_ALIAS_FAILURE',

    SET_PROFILE_EDIT_SETTINGS_LOAN_SUCCESS: 'SET_PROFILE_EDIT_SETTINGS_LOAN_SUCCESS',

    SET_INIT_API_FLAG: 'SET_INIT_API_FLAG'
};
